import api from '@/api'

export default {
  list () {
    return api.get('/banks')
  },

  find (id) {
    return api.get(`/banks/${id}`)
  },

  fetchContracts (id) {
    return api.get(`/banks/${id}/contracts`)
  }
}
